module.exports = __webpack_public_path__ + "img/banner3.53928eb3.png";